var _defs, _rect, _g, _g2, _path, _g3, _tspan, _tspan2, _tspan3, _rect2, _rect3, _tspan4, _g4, _tspan5, _rect4, _rect5, _tspan6, _tspan7, _rect6, _rect7, _tspan8, _tspan9, _rect8, _rect9, _tspan0, _tspan1, _rect0, _rect1, _tspan10, _rect10, _rect11, _tspan11, _path2, _rect12, _tspan12, _path3, _rect13, _tspan13, _path4, _tspan14, _tspan15, _rect14, _rect15, _g5, _tspan16, _tspan17, _tspan18, _rect16, _rect17, _g6, _tspan19, _tspan20, _rect18, _tspan21, _rect19, _rect20, _rect21, _rect22, _tspan22, _tspan23, _tspan24, _tspan25, _g7, _tspan26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472,
    height: 312,
    viewBox: "0 0 472 312",
    fill: "none",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame_f4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 312,
    rx: 24
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_11512_2147_f4",
    x: 1108.8,
    y: 3050,
    width: 32.9047,
    height: 22.7712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.54373
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.10228
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_11512_2147_f4",
    x: 861.795,
    y: 3070,
    width: 32.9047,
    height: 22.7712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.54373
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.10228
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_11512_2147_f4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.76791,
    height: 8.76791,
    fill: "white",
    transform: "translate(889.722 2998.77)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_11512_2147_f4",
    x: 658.7,
    y: 2681.7,
    width: 288.6,
    height: 288.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_11512_2147_f4",
    x: 1023.8,
    y: 3094,
    width: 32.9047,
    height: 22.7712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.54373
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.10228
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543711 0 0 0 0 0.0791667 0 0 0 0 0.038099 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_i_11512_2147_f4",
    x: 729,
    y: 2809,
    width: 474,
    height: 314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.29293 0 0 0 0 0.353365 0 0 0 0 0.257379 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11512_2147"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_11512_2147_f4",
    x: 1013.7,
    y: 2925.7,
    width: 349.6,
    height: 349.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.65,
    result: "effect1_foregroundBlur_11512_2147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_11512_2147_f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731 2835H1169C1174.52 2835 1179 2839.48 1179 2845V3421C1179 3426.52 1174.52 3431 1169 3431H731V2835Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_11512_2147_f4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 2811,
    width: 472,
    height: 312,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_11512_2147_f4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.76791,
    height: 8.76791,
    fill: "white",
    transform: "translate(777.384 2998.77)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_11512_2147_f4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11512_2147_f4",
    transform: "matrix(0.000400853 0 0 0.000751599 -0.278708 -0.0157088)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_11512_2147_f4",
    "data-name": "image.png",
    width: 3556,
    height: 1544,
    preserveAspectRatio: "none",
    href: "/feature-art-image0.jpg"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_11512_2147_f4",
    x: 891,
    y: 2744,
    width: 245,
    height: 195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.449829 0 0 0 0 0.577083 0 0 0 0 0.370295 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_11512_2147_f4",
    x: 932,
    y: 2783,
    width: 164,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11512_2147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11512_2147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11512_2147_f4",
    x1: 1074.83,
    y1: 2982.41,
    x2: 1074.83,
    y2: 2864.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F8F12"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame_f4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-731 -2811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 782_4_f4",
    filter: "url(#filter43_i_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_11512_2147_f4)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 2811,
    width: 472,
    height: 312,
    rx: 24,
    fill: "#17270D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1_5_f4",
    opacity: 0.38,
    filter: "url(#filter44_f_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 2826,
    r: 53,
    fill: "#4CBC18"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2_4_f4",
    opacity: 0.24,
    filter: "url(#filter45_f_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1188.5,
    cy: 3100.5,
    r: 83.5,
    fill: "#4CBC18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "rent-comps_f4"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_11512_2147_f4)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M731 2835H1169C1174.52 2835 1179 2839.48 1179 2845V3421C1179 3426.52 1174.52 3431 1169 3431H731V2835Z",
    fill: "#F4FAEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "bg-shape_f4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10_f4",
    d: "M1200.85 2976.17L1229.04 2881.76L1134.09 2905.08L1149.29 2921.27L1020.34 3045.21L1020.41 3236.07H1071.97V3067.48L1184.8 2959.05L1200.85 2976.17Z",
    fill: "#E8F5E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11_f4",
    d: "M1211.51 3019.61H1162.02V3069.6H1211.51V3019.61Z",
    fill: "#EFFCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12_f4",
    d: "M1152.64 3236.07L1300.84 3078.71V3184.77L1233.52 3184.81L1181.58 3236.07H1352.42V3058.88L1299.76 3005.67L1083.24 3236.07H1152.64Z",
    fill: "#EFFCE8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "heading_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 308_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 394_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Rent Comps_f4",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 10.9599,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 772.648,
    y: 2878.84
  }, "Rent Comps")))))), /*#__PURE__*/React.createElement("g", {
    id: "details-edit_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 310_5_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Search Criteria_f4",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8.76791,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 772.648,
    y: 2925.32
  }, "Search Criteria")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 478_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 327_2_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 326_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 435_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_21_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Property Type_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 772.648,
    y: 2947.09
  }, "Property Type"))), /*#__PURE__*/React.createElement("g", {
    id: "input_22_f4"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 772.922,
    y: 2951.68,
    width: 145.218,
    height: 21.3718,
    rx: 1.91798,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 772.922,
    y: 2951.68,
    width: 145.218,
    height: 21.3718,
    rx: 1.91798,
    stroke: "#E3E9E0",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("text", {
    id: "Single-Family_f4",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 777.032,
    y: 2964.74
  }, "Single-Family"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "stash:chevron-up-light_f4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13_f4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M912.033 2961.08C912.058 2961.1 912.078 2961.13 912.092 2961.17C912.106 2961.2 912.113 2961.24 912.113 2961.27C912.113 2961.31 912.106 2961.34 912.092 2961.38C912.078 2961.41 912.058 2961.44 912.033 2961.47L909.647 2963.85L907.261 2961.47C907.209 2961.42 907.18 2961.35 907.18 2961.27C907.18 2961.2 907.209 2961.13 907.261 2961.08C907.312 2961.03 907.382 2961 907.455 2961C907.527 2961 907.597 2961.03 907.649 2961.08L909.647 2963.08L911.645 2961.08C911.67 2961.05 911.7 2961.03 911.734 2961.02C911.767 2961.01 911.803 2961 911.839 2961C911.875 2961 911.91 2961.01 911.944 2961.02C911.977 2961.03 912.007 2961.05 912.033 2961.08Z",
    fill: "#17270D"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 475_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_23_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Beds_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 927.183,
    y: 2947.09
  }, "Beds"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 436_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_24_f4"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 927.457,
    y: 2951.68,
    width: 25.7557,
    height: 21.3718,
    rx: 1.91798,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 927.457,
    y: 2951.68,
    width: 25.7557,
    height: 21.3718,
    rx: 1.91798,
    stroke: "#E3E9E0",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("text", {
    id: "3_f4",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 938.335,
    y: 2964.74
  }, "3")))))), /*#__PURE__*/React.createElement("g", {
    id: "input_25_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Baths_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 962.254,
    y: 2947.09
  }, "Baths"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 436_2_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_26_f4"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 962.528,
    y: 2951.68,
    width: 25.7557,
    height: 21.3718,
    rx: 1.91798,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 962.528,
    y: 2951.68,
    width: 25.7557,
    height: 21.3718,
    rx: 1.91798,
    stroke: "#E3E9E0",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("text", {
    id: "2_f4",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 973.406,
    y: 2964.74
  }, "2")))))), /*#__PURE__*/React.createElement("g", {
    id: "input_27_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sqft_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 997.326,
    y: 2947.09
  }, "Sqft"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 436_3_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_28_f4"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 997.6,
    y: 2951.68,
    width: 32.8797,
    height: 21.3718,
    rx: 1.91798,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 997.6,
    y: 2951.68,
    width: 32.8797,
    height: 21.3718,
    rx: 1.91798,
    stroke: "#E3E9E0",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("text", {
    id: "1,523_f4",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 1005.54,
    y: 2964.74
  }, "1,523")))))), /*#__PURE__*/React.createElement("g", {
    id: "input_29_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Year Built_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 1039.52,
    y: 2947.09
  }, "Year Built"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 436_4_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_30_f4"
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1039.8,
    y: 2951.68,
    width: 32.8797,
    height: 21.3718,
    rx: 1.91798,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1039.8,
    y: 2951.68,
    width: 32.8797,
    height: 21.3718,
    rx: 1.91798,
    stroke: "#E3E9E0",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("text", {
    id: "1984_f4",
    fill: "#1A2A10",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1048.24,
    y: 2964.74
  }, "1984")))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 11_f4"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "image 58_3_f4",
    x: 772.922,
    y: 3035.27,
    width: 657.045,
    height: 350.168,
    rx: 4.10996,
    fill: "url(#pattern2_11512_2147_f4)",
    stroke: "#DAE4D5",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 447_3_f4",
    filter: "url(#filter46_d_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_19_f4"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1026,
    y: 3094,
    width: 28.4957,
    height: 13.7833,
    rx: 6.89164,
    fill: "#365F87"
  })), /*#__PURE__*/React.createElement("text", {
    id: "1990_f4",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.02794,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1033.25,
    y: 3102.52
  }, "1990")))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_19_f4",
    d: "M1040.25 3112.02L1037.28 3107.78L1043.22 3107.78L1040.25 3112.02Z",
    fill: "#365F87"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 452_5_f4",
    filter: "url(#filter47_d_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_20_f4"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 3070,
    width: 28.4957,
    height: 13.7833,
    rx: 6.89164,
    fill: "#365F87"
  })), /*#__PURE__*/React.createElement("text", {
    id: "1475_f4",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.02794,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 871.248,
    y: 3078.52
  }, "1475")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_20_f4",
    d: "M878.248 3088.02L875.28 3083.78L881.216 3083.78L878.248 3088.02Z",
    fill: "#365F87"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 447_4_f4",
    filter: "url(#filter48_d_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 18_21_f4"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1111,
    y: 3050,
    width: 28.4957,
    height: 13.7833,
    rx: 6.89164,
    fill: "#365F87"
  })), /*#__PURE__*/React.createElement("text", {
    id: "1750_f4",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.02794,
    fontWeight: 900,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1118.25,
    y: 3058.52
  }, "1750")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_21_f4",
    d: "M1125.25 3068.02L1122.28 3063.78L1128.22 3063.78L1125.25 3068.02Z",
    fill: "#365F87"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "4321 Oak Avenue, Denver, CO 80202_f4",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 772.648,
    y: 2896.68
  }, "4321 Oak Avenue, Denver, CO 80202"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 476_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input_31_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Radius_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 773,
    y: 2987.88
  }, "Radius"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 478_2_f4"
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 773.274,
    y: 2992.47,
    width: 103.023,
    height: 21.3718,
    rx: 1.91798,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 773.274,
    y: 2992.47,
    width: 103.023,
    height: 21.3718,
    rx: 1.91798,
    stroke: "#E3E9E0",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 480_f4"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icon-input-target_f4",
    clipPath: "url(#clip16_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3_f4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14_f4",
    d: "M781.769 2999.11V3000.41M781.769 3005.89V3007.19M777.728 3003.15H779.029M784.509 3003.15H785.811M783.139 3000.01C784.348 3000.54 785.194 3001.75 785.194 3003.15C785.194 3005.04 783.658 3006.58 781.769 3006.58C779.881 3006.58 778.344 3005.04 778.344 3003.15C778.344 3001.26 779.881 2999.73 781.769 2999.73",
    stroke: "#A7C199",
    strokeWidth: 0.547994,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15_f4",
    d: "M781.768 3003.84C782.147 3003.84 782.453 3003.53 782.453 3003.15C782.453 3002.77 782.147 3002.47 781.768 3002.47C781.39 3002.47 781.083 3002.77 781.083 3003.15C781.083 3003.53 781.39 3003.84 781.768 3003.84Z",
    stroke: "#A7C199",
    strokeWidth: 0.547994,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "1.5_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 790.536,
    y: 3005.53
  }, "1.5")))), /*#__PURE__*/React.createElement("text", {
    id: "mi_f4",
    fill: "#8A9A85",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 864.187,
    y: 3005.53
  }, "mi"))))), /*#__PURE__*/React.createElement("g", {
    id: "input_32_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Find Comps Within_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 885.338,
    y: 2987.88
  }, "Find Comps Within"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 479_f4"
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 885.612,
    y: 2992.47,
    width: 103.023,
    height: 21.3718,
    rx: 1.91798,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 885.612,
    y: 2992.47,
    width: 103.023,
    height: 21.3718,
    rx: 1.91798,
    stroke: "#E3E9E0",
    strokeWidth: 0.547994
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 481_f4"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Frame_f4",
    clipPath: "url(#clip17_11512_2147_f4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_f4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16_f4",
    d: "M891.247 2999.15V3000.29H892.39",
    stroke: "#A7C199",
    strokeWidth: 0.547994,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17_f4",
    d: "M890.065 3003.15C890.065 3005.38 891.874 3007.19 894.106 3007.19C896.338 3007.19 898.147 3005.38 898.147 3003.15C898.147 3000.92 896.338 2999.11 894.106 2999.11C892.99 2999.11 891.98 2999.56 891.248 3000.29",
    stroke: "#A7C199",
    strokeWidth: 0.547994,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18_f4",
    d: "M894.104 3001.13V3003.13L895.471 3004.5",
    stroke: "#A7C199",
    strokeWidth: 0.547994,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "12_f4",
    fill: "#4F5F4A",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 902.874,
    y: 3005.53
  }, "12")))), /*#__PURE__*/React.createElement("text", {
    id: "months_f4",
    fill: "#8A9A85",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 959.525,
    y: 3005.53
  }, "months")))))), /*#__PURE__*/React.createElement("g", {
    id: "btn_4_f4"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 996,
    y: 2992,
    width: 76,
    height: 22,
    rx: 11,
    fill: "#4CBC18"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Search_f4",
    fill: "white",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 7.12393,
    fontWeight: 600,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 1022.5,
    y: 3005.07
  }, "Search")))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-731 -2811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 31_2_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 28_2_f4",
    filter: "url(#filter49_d_11512_2147_f4)",
    "data-figma-bg-blur-radius": 4
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 931,
    y: 2784,
    width: 165,
    height: 115,
    rx: 24,
    fill: "white",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 931.25,
    y: 2784.25,
    width: 164.5,
    height: 114.5,
    rx: 23.75,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 23_3_f4",
    filter: "url(#filter50_d_11512_2147_f4)"
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 2793,
    width: 144,
    height: 97,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arv-estimate_3_f4"
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 949,
    y: 2800,
    width: 131,
    height: 81,
    rx: 4.07273,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 310_6_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Est. Market Rent_f4",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 979.5,
    y: 2814.76
  }, "Est. Market Rent")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 437_3_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9_3_f4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "$1,640_f4",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.61818,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 955.004,
    y: 2876.94
  }, "$1,640"))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 703_3_f4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "$1,800 $1.20/sqft_f4"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 18,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 986.854,
    y: 2840.09
  }, "$1,800\n"))), /*#__PURE__*/React.createElement("text", {
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 997.077,
    y: 2854.09
  }, "$1.20/sqft"))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group 8_2_f4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 376_2_f4",
    x: 1072.83,
    y: 2864.57,
    width: 3.98523,
    height: 117.833,
    rx: 1.99262,
    transform: "rotate(90 1072.83 2864.57)",
    fill: "url(#paint2_linear_11512_2147_f4)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "$1,950_f4",
    fill: "#17270D",
    style: {
      whiteSpace: "pre"
    },
    xmlSpace: "preserve",
    fontFamily: "Figtree",
    fontSize: 6.61818,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 1053.87,
    y: 2876.94
  }, "$1,950")))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature-4.84694dfd00c47bc6aa23befab6fe9ead.svg";
export { ForwardRef as ReactComponent };